module.exports = __webpack_public_path__ + "img/Carlsberg.800f0855.svg";